{
  "LOGIN": {
    "TITLE": "Вход в контактния център",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Please enter a valid email address"
    },
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login Successful",
      "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно",
      "UNAUTH": "Username / Password Incorrect. Please try again",
      "ACCOUNT_DEACTIVATED": "Вашият акаунт е деактивиран. Моля, свържете се с вашия администратор.",
      "PASSWORD_LOGIN_DISABLED": "Вход с парола е изключен за вашия акаунт. Моля, влезте чрез OAuth (напр. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Forgot your password?",
    "CREATE_NEW_ACCOUNT": "Create new account",
    "SUBMIT": "Login"
  }
}
